import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import WidgetComponent from "../../components/Widget";
import PersonalContext from "./PersonalContext";
import CheckBoxInsurance from "../../components/CheckBoxInsurance";
import { Accordion } from "react-bootstrap";
import CoverDetails from "../../components/CoverDetailsModal";
import DataService from "../../service/data";
import { TYPE_CODES } from "../../const";
class PersonalStep1 extends Component {
  state = {
    selected: "",
    show: false,
    coverDetails: []
  };
  constructor(props) {
    super(props);
  }

  _onChangePlan = selected => {
    this.setState({ ...this.state, selected });
  };

  showModal = () => {
    const { step1 } = this.context;
    const { selectedPlan } = this.context;
    const { coverDetails } = this.state;

    this.setState({ show: true }, () => {
      if (coverDetails.length === 0) {
        setTimeout(() => {
          this.initCoverDetail(TYPE_CODES.PA, selectedPlan, "1");
        }, 1000);
      }
    });
  };

  hideModal = () => {
    this.setState({ show: false });
  };

  async initCoverDetail(productCode, selectedPackage, custOrder) {
    try {
      const callers = [];

      callers.push(
        DataService.getCoverDetails({
          product_code: productCode,
          package_code: selectedPackage,
          cust_order: custOrder
        })
      );

      const responses = await Promise.all(callers);

      this.setState({
        ...this.state,
        coverDetails: responses[0]
      });
      // console.log("responses[0]:", responses[0]);
    } catch (err) {
      console.log(err);
    }
  }
  render() {
    const { step1 } = this.context;
    const { 
      planList, 
      selectedPlan, 
      acceptInsurance,
      acceptHealthCheck, 
      onChangeModel 
    } = step1;
    const { show, coverDetails } = this.state;

    return (
      <div className="form-wrapper">
        <Accordion
          className="accordion-widget-wrapper"
          defaultActiveKey={selectedPlan}
        >
          {planList.map((item, index) => {
            return (
              <Fragment>
                <WidgetComponent
                  key={index}
                  listItem={item}
                  selected={selectedPlan}
                  showModal={this.showModal}
                  onChangePlan={selected =>
                    onChangeModel({ name: "selectedPlan", value: selected })
                  }
                />
              </Fragment>
            );
          })}

          <CoverDetails
            show={show}
            hideModal={this.hideModal}
            listItem={planList} //item
            insurance_type={"ประกันอุบัติเหตุ"}
            productCode={TYPE_CODES.PA}
            selectedPackage={selectedPlan}
            custOrder={"1"}
            coverDetails={coverDetails}
          />
        </Accordion>
        <CheckBoxInsurance
          checked={acceptInsurance}
          checked3={acceptHealthCheck}
          onCheckChange={(name, checked) =>
            onChangeModel({ name: name, value: checked })
          }
        />
      </div>
    );
  }
}
PersonalStep1.contextType = PersonalContext;
export default withRouter(PersonalStep1);
